import * as e from "react";
import { useState as w, useRef as Y, useCallback as de, useEffect as ae, Fragment as Je } from "react";
import { bN as qe } from "./OBTResizeContainer-B1pWRZTC.js";
import { A as sl, a as rl, b as cl, c as ll, d as il, C as dl, e as _l, f as ml, g as ul, h as pl, i as El, j as bl, k as fl, l as yl, m as gl, n as hl, o as vl, p as kl, q as Nl, r as $l, s as wl, t as Al, u as xl, v as Xl, w as Sl, x as Cl, y as Fl, z as Bl, B as jl, D as Ll, E as Il, F as Dl, G as Ml, H as Rl, I as Tl, J as Pl, K as Ol, L as Gl, M as ql, N as zl, O as Wl, P as Kl, Q as Hl, R as Vl, S as Ul, T as Ql, U as Jl, V as Yl, W as Zl, X as ei, Y as ti, Z as ai, _ as ni, $ as oi, a0 as si, a1 as ri, a2 as ci, a3 as li, a4 as ii, a5 as di, a6 as _i, a7 as mi, a8 as ui, a9 as pi, aa as Ei, ab as bi, ac as fi, ad as yi, ae as gi, af as hi, ag as vi, ah as ki, ai as Ni, aj as $i, ak as wi, al as Ai, am as xi, an as Xi, ao as Si, ap as Ci, aq as Fi, ar as Bi, as as ji, at as Li, au as Ii, av as Di, aw as Mi, ax as Ri, ay as Ti, az as Pi, aA as Oi, bO as Gi, aB as qi, aC as zi, aD as Wi, aE as Ki, aF as Hi, aG as Vi, aH as Ui, aI as Qi, aJ as Ji, aK as Yi, aL as Zi, aM as ed, aN as td, aO as ad, aP as nd, aQ as od, aR as sd, aS as rd, aT as cd, aU as ld, aV as id, aW as dd, aX as _d, aY as md, aZ as ud, a_ as pd, a$ as Ed, b0 as bd, b1 as fd, b2 as yd, b3 as gd, b4 as hd, b5 as vd, b6 as kd, b7 as Nd, b8 as $d, b9 as wd, ba as Ad, bb as xd, bc as Xd, bd as Sd, be as Cd, bf as Fd, bg as Bd, bh as jd, bi as Ld, bj as Id, bk as Dd, bl as Md, bm as Rd, bn as Td, bo as Pd, bp as Od, bq as Gd, br as qd, bs as zd, bt as Wd, bu as Kd, bv as Hd, bw as Vd, bx as Ud, by as Qd, bz as Jd, bA as Yd, bB as Zd, bC as e_, bD as t_, bE as a_, bF as n_, bG as o_, bH as s_, bI as r_, bJ as c_, bK as l_, bL as i_, bM as d_ } from "./OBTResizeContainer-B1pWRZTC.js";
const gc = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Se = "poc_portal_token", ye = "poc_portal_refresh", Ae = "auth:session-expired", ze = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let We = ze + "/chat-api/api/auth";
function hc(t) {
  t.authBase && (We = t.authBase);
}
function Ce(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function Ye(t, a = 30) {
  const n = Ce(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function Ke(t = 30) {
  const a = localStorage.getItem(ye);
  if (!a) return !0;
  const n = Ce(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function Ze() {
  return localStorage.getItem(Se);
}
function et(t, a) {
  localStorage.setItem(Se, t), a && localStorage.setItem(ye, a);
}
function tt() {
  localStorage.removeItem(Se), localStorage.removeItem(ye), He();
}
function be() {
  tt(), window.dispatchEvent(new Event(Ae));
}
function vc(t) {
  return window.addEventListener(Ae, t), () => window.removeEventListener(Ae, t);
}
let fe = null;
const at = 2147483647;
function nt() {
  if (He(), Ke()) {
    be();
    return;
  }
  const t = localStorage.getItem(ye), a = t ? Ce(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), at);
  fe = setTimeout(() => {
    fe = null, nt();
  }, n);
}
function He() {
  fe !== null && (clearTimeout(fe), fe = null);
}
let Ne = null;
function Ve() {
  return Ne || (Ne = ot()), Ne;
}
async function ot() {
  try {
    return await st();
  } finally {
    Ne = null;
  }
}
async function st() {
  const t = localStorage.getItem(ye);
  if (!t)
    return be(), null;
  let a;
  try {
    a = await fetch(We + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok)
    return a.status < 500 && be(), null;
  const n = await a.json().catch(() => ({}));
  return n.access_token ? (et(n.access_token, n.refresh_token), n.access_token) : (be(), null);
}
async function rt() {
  if (Ke())
    return be(), null;
  const t = Ze();
  return t && !Ye(t) ? t : Ve();
}
async function ge(t, a = {}) {
  const n = (s) => {
    var l;
    return {
      ...a,
      headers: { ...(l = a.headers) != null ? l : {}, ...s ? { Authorization: "Bearer " + s } : {} }
    };
  }, o = await rt();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await Ve();
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
let le = ze + "/chat-api/api/comments";
function kc(t) {
  t.base && (le = t.base);
}
function ct(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function he(t) {
  var n;
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error((n = a.error) != null ? n : `요청 실패 (${t.status})`);
  return a;
}
async function Fe(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await ge(`${le}?${s}`, { cache: "no-store", signal: r });
  return he(l);
}
async function lt(t, a, n, o) {
  const r = await ge(le, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return he(r);
}
async function it(t, a) {
  const n = await ge(`${le}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return he(n);
}
async function dt(t) {
  const a = await ge(`${le}/${t}`, { method: "DELETE" });
  return (await he(a)).status;
}
async function _t(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await ge(`${le}/counts?${o}`, { cache: "no-store", signal: n });
  return (await he(r)).counts;
}
const Be = 50;
function xe(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function mt(t, a) {
  if (xe(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function _e(t, a) {
  return t instanceof Error && t.message ? t.message : a;
}
function ut(t, a) {
  const [n, o] = w([]), [r, s] = w(!0), [l, i] = w(!0), [c, d] = w(null), [m, _] = w(0), [u, b] = w(0), y = t + " " + a, E = Y(y);
  E.current = y;
  const [h, $] = w(0), X = de(() => $((f) => f + 1), []);
  ae(() => {
    const f = new AbortController(), v = y;
    return o([]), b(0), _(0), d(null), s(!0), i(!0), Fe(t, a, 0, Be, f.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || d(_e(g, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      E.current === v && (s(!1), i(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(xe).length < m, G = de(() => {
    if (r || !O) return;
    const f = u + 1, v = E.current;
    s(!0), Fe(t, a, f, Be).then((g) => {
      E.current === v && (o((C) => [...C, ...g.items]), _(g.total), b(f));
    }).catch((g) => {
      E.current === v && d(_e(g, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), V = de(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const C = -Date.now(), F = {
      id: C,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((L) => mt(L, F)), d(null);
    try {
      const L = await lt(t, a, g, v);
      return E.current !== D || (o((U) => U.map((k) => k.id === C ? L : k)), v === void 0 && _((U) => U + 1)), !0;
    } catch (L) {
      return E.current !== D || (o((U) => U.filter((k) => k.id !== C)), d(_e(L, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [t, a]), S = de(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const C = E.current;
    try {
      const F = await it(f, g);
      return E.current !== C || o((D) => D.map((L) => L.id === f ? F : L)), !0;
    } catch (F) {
      return E.current === C && d(_e(F, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), ie = de(async (f) => {
    const v = E.current;
    try {
      const g = await dt(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((C) => C.map((F) => F.id === f ? { ...F, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : F)), !0) : (o((C) => {
        const F = C.find((k) => k.id === f), D = C.filter((k) => k.id !== f);
        if (!F) return D;
        if (xe(F))
          return _((k) => Math.max(0, k - 1)), D;
        const L = F.parentId, U = D.find((k) => k.id === L);
        return U && U.deleted && !D.some((k) => k.parentId === L) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== L)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && d(_e(g, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: G,
    reload: X,
    add: V,
    edit: S,
    remove: ie
  };
}
const pt = "_thread_1layy_9", Et = "_head_1layy_28", bt = "_headTitle_1layy_37", ft = "_headCount_1layy_43", yt = "_list_1layy_54", gt = "_row_1layy_61", ht = "_isReply_1layy_73", vt = "_pending_1layy_80", kt = "_avatar_1layy_84", Nt = "_avatarGhost_1layy_98", $t = "_body_1layy_103", wt = "_meta_1layy_108", At = "_author_1layy_116", xt = "_dept_1layy_122", Xt = "_time_1layy_130", St = "_text_1layy_135", Ct = "_textDeleted_1layy_143", Ft = "_acts_1layy_148", Bt = "_act_1layy_148", jt = "_actDanger_1layy_169", Lt = "_empty_1layy_175", It = "_error_1layy_182", Dt = "_skeleton_1layy_196", Mt = "_more_1layy_219", Rt = "_foot_1layy_245", Tt = "_composer_1layy_252", Pt = "_composerInput_1layy_261", Ot = "_composerActions_1layy_284", Gt = "_btn_1layy_291", qt = "_btnPrimary_1layy_301", zt = "_btnGhost_1layy_310", p = {
  thread: pt,
  head: Et,
  headTitle: bt,
  headCount: ft,
  list: yt,
  row: gt,
  isReply: ht,
  pending: vt,
  avatar: kt,
  avatarGhost: Nt,
  body: $t,
  meta: wt,
  author: At,
  dept: xt,
  time: Xt,
  text: St,
  textDeleted: Ct,
  acts: Ft,
  act: Bt,
  actDanger: jt,
  empty: Lt,
  error: It,
  skeleton: Dt,
  more: Mt,
  foot: Rt,
  composer: Tt,
  composerInput: Pt,
  composerActions: Ot,
  btn: Gt,
  btnPrimary: qt,
  btnGhost: zt
}, je = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Wt(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return je[a % je.length];
}
function Kt(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Le = 6e4, Ie = 36e5, De = 864e5, Ht = 6048e5;
function Vt(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Le) return "방금";
  if (n < Ie) return `${Math.floor(n / Le)}분 전`;
  if (n < De) return `${Math.floor(n / Ie)}시간 전`;
  if (n < Ht) return `${Math.floor(n / De)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Xe({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, i] = w(o != null ? o : ""), [c, d] = w(!1), m = Y(null);
  ae(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    d(!0);
    const b = await r(u);
    d(!1), b && i("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => i(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function Ut({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: i,
  onCancel: c
}) {
  var u, b;
  const d = ct(t), m = d ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: Wt(_) } }, Kt(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, Vt(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Xe,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !d && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: i
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Xe,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Nc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: i, initialLoading: c, loading: d, error: m, count: _, hasMore: u, loadMore: b, reload: y, add: E, edit: h, remove: $ } = ut(t, a), [X, R] = w(null), [O, G] = w(null);
  ae(() => {
    R(null), G(null);
  }, [t, a]);
  const V = Y(n);
  return V.current = n, ae(() => {
    !c && V.current && V.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && i.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), i.map((S) => /* @__PURE__ */ e.createElement(
    Ut,
    {
      key: S.id,
      item: S,
      replying: X === S.id,
      editing: O === S.id,
      onReply: () => {
        G(null), R(S.id);
      },
      onEdit: () => {
        R(null), G(S.id);
      },
      onCancel: () => {
        R(null), G(null);
      },
      onSubmitReply: async (ie) => {
        const f = await E(ie, S.id);
        return f && R(null), f;
      },
      onSubmitEdit: async (ie) => {
        const f = await h(S.id, ie);
        return f && G(null), f;
      },
      onDelete: () => {
        $(S.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: d }, d ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Xe,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (S) => E(S)
    }
  )));
}
function $c(t, a) {
  const [n, o] = w({}), [r, s] = w(!1), [l, i] = w(0), c = a.join(",");
  return ae(() => {
    const d = c ? c.split(",") : [];
    if (d.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), _t(t, d, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => i((d) => d + 1)
  };
}
const Qt = "_card_epi3f_1", Jt = "_header_epi3f_8", Yt = "_headerNoDivider_epi3f_13", Zt = "_body_epi3f_17", ea = "_paddingSm_epi3f_22", ta = "_paddingMd_epi3f_26", aa = "_paddingLg_epi3f_30", q = {
  card: Qt,
  header: Jt,
  headerNoDivider: Yt,
  body: Zt,
  paddingSm: ea,
  paddingMd: ta,
  paddingLg: aa
};
function wc({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: i,
  className: c
}) {
  const d = typeof n == "number" ? "" : n === "sm" ? q.paddingSm : n === "lg" ? q.paddingLg : q.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${q.card} ${c}` : q.card, u = r ? q.header : `${q.header} ${q.headerNoDivider}`, b = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...i !== void 0 ? { borderBottomColor: i } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${q.body} ${d}`, style: m }, t));
}
const na = "_horizontal_mkht7_1", oa = "_vertical_mkht7_8", Me = {
  horizontal: na,
  vertical: oa
};
function Ac({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? Me.vertical : Me.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const sa = "_root_nvy8t_1", ra = "_icon_nvy8t_7", ca = "_iconBadge_nvy8t_15", la = "_titleGroup_nvy8t_25", ia = "_title_nvy8t_25", da = "_subtitle_nvy8t_41", _a = "_trailing_nvy8t_49", ma = "_closeButton_nvy8t_58", Q = {
  root: sa,
  icon: ra,
  iconBadge: ca,
  titleGroup: la,
  title: ia,
  subtitle: da,
  trailing: _a,
  closeButton: ma
};
function xc({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: i,
  titleSize: c,
  subtitle: d,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: b
}) {
  const y = {
    ...i !== void 0 ? { fontWeight: i } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), d && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, d)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const ua = "_badge_19977_1", pa = {
  badge: ua
};
function Xc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: pa.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const Ea = "_wrapper_ccmq2_1", ba = "_image_ccmq2_8", fa = "_fallback_ccmq2_16", ya = "_statusDot_ccmq2_29", ve = {
  wrapper: Ea,
  image: ba,
  fallback: fa,
  statusDot: ya
}, ga = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function ha(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const $e = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function va(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return $e[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return $e[Math.abs(n) % $e.length];
}
function Ue({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: i = "#fff"
}) {
  var _;
  const [c, d] = w(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ve.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${i}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ve.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => d(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.fallback,
        style: {
          backgroundColor: s != null ? s : va(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      ha(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ve.statusDot,
        style: {
          backgroundColor: ga[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const ka = "_stack_y8phg_1", Na = "_item_y8phg_6", $a = "_overflow_y8phg_18", ke = {
  stack: ka,
  item: Na,
  overflow: $a
};
function Sc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: ke.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: ke.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(Ue, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: ke.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const wa = "_badge_1mjda_1", Aa = "_pill_1mjda_15", xa = "_dot_1mjda_19", Xa = "_dotPulse_1mjda_26", Sa = "_outline_1mjda_40", Ca = "_soft_1mjda_46", me = {
  badge: wa,
  pill: Aa,
  dot: xa,
  dotPulse: Xa,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: Sa,
  soft: Ca
};
function Cc({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: i,
  dotPulse: c = !1,
  border: d = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), d && (_.borderColor = m);
  const u = [
    me.badge,
    me[a],
    s === "pill" ? me.pill : ""
  ].filter(Boolean).join(" "), b = [me.dot, c ? me.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: i != null ? i : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Fa = "_row_1k2ap_1", Ba = "_reply_1k2ap_7", ja = "_avatar_1k2ap_12", La = "_avatarImage_1k2ap_25", Ia = "_avatarFallback_1k2ap_32", Da = "_body_1k2ap_44", Ma = "_headerLine_1k2ap_49", Ra = "_author_1k2ap_56", Ta = "_meta_1k2ap_62", Pa = "_text_1k2ap_67", Oa = "_actionsRow_1k2ap_74", Ga = "_actionBtn_1k2ap_81", B = {
  row: Fa,
  reply: Ba,
  avatar: ja,
  avatarImage: La,
  avatarFallback: Ia,
  body: Da,
  headerLine: Ma,
  author: Ra,
  meta: Ta,
  text: Pa,
  actionsRow: Oa,
  actionBtn: Ga
};
function qa(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function Fc({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: i,
  onReplyClick: c
}) {
  const [d, m] = w(!1), _ = !!t && !d;
  return /* @__PURE__ */ e.createElement("div", { className: `${B.row} ${l ? B.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: B.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: B.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: B.avatarFallback }, qa(a))), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: B.headerLine }, /* @__PURE__ */ e.createElement("span", { className: B.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: B.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: B.text }, o), /* @__PURE__ */ e.createElement("div", { className: B.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: i }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const za = "_wrapper_79n51_1", Wa = {
  wrapper: za
}, Ka = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, Ha = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function Va({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = Ka[n]) != null ? l : Ha;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Wa.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const Ua = "_chip_1jhj8_1", Qa = "_clickable_1jhj8_12", Ja = "_icon_1jhj8_21", Ya = "_info_1jhj8_26", Za = "_name_1jhj8_33", en = "_size_1jhj8_42", tn = "_chipError_1jhj8_48", an = "_chipDone_1jhj8_53", nn = "_status_1jhj8_57", on = "_statusError_1jhj8_66", sn = "_statusDone_1jhj8_67", rn = "_statusIcon_1jhj8_69", cn = "_statusLabel_1jhj8_71", ln = "_progressTrack_1jhj8_78", dn = "_progressFill_1jhj8_88", _n = "_actionBtn_1jhj8_96", N = {
  chip: Ua,
  clickable: Qa,
  icon: Ja,
  info: Ya,
  name: Za,
  size: en,
  chipError: tn,
  chipDone: an,
  status: nn,
  statusError: on,
  statusDone: sn,
  statusIcon: rn,
  statusLabel: cn,
  progressTrack: ln,
  progressFill: dn,
  actionBtn: _n
};
function Bc({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: i,
  percent: c
}) {
  const d = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${d}`,
      onClick: s,
      title: l === "error" ? i : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(Va, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), i ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, i)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "download",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "remove",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const mn = "_list_1yxwc_1", un = "_row_1yxwc_6", pn = "_inline_1yxwc_15", En = "_label_1yxwc_22", bn = "_value_1yxwc_29", fn = "_stacked_1yxwc_35", yn = "_bold_1yxwc_51", ne = {
  list: mn,
  row: un,
  inline: pn,
  label: En,
  value: bn,
  stacked: fn,
  bold: yn
};
function jc({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const gn = "_container_2r163_1", hn = "_row_2r163_5", vn = "_clickable_2r163_12", kn = "_leading_2r163_20", Nn = "_main_2r163_26", $n = "_titleLine_2r163_34", wn = "_title_2r163_34", An = "_tags_2r163_50", xn = "_meta_2r163_57", Xn = "_actions_2r163_62", Sn = "_expandable_2r163_69", M = {
  container: gn,
  row: hn,
  clickable: vn,
  leading: kn,
  main: Nn,
  titleLine: $n,
  title: wn,
  tags: An,
  meta: xn,
  actions: Xn,
  expandable: Sn
};
function Lc({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: i
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${i ? M.clickable : ""}`, onClick: i }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const Cn = "_row_xzgny_1", Fn = "_info_xzgny_8", Bn = "_name_xzgny_16", jn = "_subtitle_xzgny_25", Ln = "_status_xzgny_33", ue = {
  row: Cn,
  info: Fn,
  name: Bn,
  subtitle: jn,
  status: Ln
};
function Ic({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: ue.row }, /* @__PURE__ */ e.createElement(Ue, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: ue.info }, /* @__PURE__ */ e.createElement("span", { className: ue.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: ue.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ue.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const In = "_row_qoxwr_1", Dn = "_clickable_qoxwr_9", Mn = "_rank_qoxwr_17", Rn = "_title_qoxwr_25", Tn = "_trailing_qoxwr_36", pe = {
  row: In,
  clickable: Dn,
  rank: Mn,
  title: Rn,
  trailing: Tn
}, Pn = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function Dc({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : Pn[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${pe.row} ${r ? pe.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: pe.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: pe.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: pe.trailing }, o));
}
const On = "_badge_1qibj_1", Gn = "_sm_1qibj_11", qn = "_md_1qibj_16", zn = "_overdue_1qibj_21", Wn = "_warning_1qibj_26", Kn = "_progress_1qibj_31", Hn = "_success_1qibj_36", Vn = "_info_1qibj_41", Un = "_neutral_1qibj_46", we = {
  badge: On,
  sm: Gn,
  md: qn,
  overdue: zn,
  warning: Wn,
  progress: Kn,
  success: Hn,
  info: Vn,
  neutral: Un
};
function Mc({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${we.badge} ${we[a]} ${we[n]}`, style: s }, t);
}
const Qn = "_wrapper_14p14_1", Jn = "_avatar_14p14_11", Yn = "_body_14p14_21", Zn = "_message_14p14_26", eo = "_dots_14p14_32", to = "_dot_14p14_32", ao = "_action_14p14_70", no = "_actionIcon_14p14_89", oo = "_gradientWrapper_14p14_95", so = "_bareIcon_14p14_100", ro = "_ctaButton_14p14_109", A = {
  wrapper: Qn,
  avatar: Jn,
  body: Yn,
  message: Zn,
  dots: eo,
  dot: to,
  action: ao,
  actionIcon: no,
  gradientWrapper: oo,
  bareIcon: so,
  ctaButton: ro
};
function Re() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Te() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Rc({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: i = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [A.wrapper, c ? A.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${i[0]}, ${i[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: A.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(Re, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: A.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(Re, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: A.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: A.dots }, /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: A.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Te, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Te, null) : o)
    ))
  );
}
const co = "_wrapper_68zkp_1", lo = "_bordered_68zkp_13", io = "_compact_68zkp_17", _o = "_icon_68zkp_23", mo = "_title_68zkp_31", uo = "_description_68zkp_38", po = "_action_68zkp_46", Z = {
  wrapper: co,
  bordered: lo,
  compact: io,
  icon: _o,
  title: mo,
  description: uo,
  action: po
};
function Eo() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function Tc({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: i,
  onAction: c,
  bordered: d = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [Z.wrapper, d && !m ? Z.bordered : "", m ? Z.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: Z.icon }, t != null ? t : /* @__PURE__ */ e.createElement(Eo, null)),
    /* @__PURE__ */ e.createElement("p", { className: Z.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: Z.description }, l),
    i && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: Z.action, onClick: c }, i)
  );
}
const bo = "_wrapper_oide4_1", fo = "_toggle_oide4_7", yo = "_toggleOpen_oide4_29", go = "_panel_oide4_34", ho = "_text_oide4_41", Ee = {
  wrapper: bo,
  toggle: fo,
  toggleOpen: yo,
  panel: go,
  text: ho
};
function Pc({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Ee.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [Ee.toggle, n ? Ee.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: Ee.panel }, /* @__PURE__ */ e.createElement("p", { className: Ee.text }, a)));
}
const vo = "_wrapper_96dw1_1", ko = "_labelRow_96dw1_8", No = "_label_96dw1_8", $o = "_value_96dw1_21", wo = "_track_96dw1_27", Ao = "_xs_96dw1_35", xo = "_sm_96dw1_39", Xo = "_md_96dw1_43", So = "_square_96dw1_47", Co = "_fill_96dw1_51", z = {
  wrapper: vo,
  labelRow: ko,
  label: No,
  value: $o,
  track: wo,
  xs: Ao,
  sm: xo,
  md: Xo,
  square: So,
  fill: Co
};
function Oc({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: i,
  trackColor: c
}) {
  const d = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / d * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...i !== void 0 ? { height: i } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: z.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: z.labelRow }, /* @__PURE__ */ e.createElement("span", { className: z.label }, n), /* @__PURE__ */ e.createElement("span", { className: z.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [z.track, z[s], l ? "" : z.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [z.fill, l ? "" : z.square].join(" "), style: _ })));
}
const Fo = "_list_aixh6_1", Bo = "_vertical_aixh6_8", jo = "_horizontal_aixh6_13", Lo = "_item_aixh6_18", Io = "_iconWrap_aixh6_41", Do = "_iconSvg_aixh6_51", Mo = "_spin_aixh6_56", Ro = "_label_aixh6_70", To = "_item_active_aixh6_82", Po = "_item_done_aixh6_87", Oo = "_connector_aixh6_91", Go = "_cardList_aixh6_114", qo = "_cardItem_aixh6_122", zo = "_card_pending_aixh6_133", Wo = "_card_active_aixh6_142", Ko = "_card_done_aixh6_152", x = {
  list: Fo,
  vertical: Bo,
  horizontal: jo,
  item: Lo,
  iconWrap: Io,
  iconSvg: Do,
  spin: Mo,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Ro,
  item_active: To,
  item_done: Po,
  connector: Oo,
  cardList: Go,
  cardItem: qo,
  card_pending: zo,
  card_active: Wo,
  card_done: Ko
};
function Ho({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function Gc({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(Ho, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const Vo = "_wrapper_1ohmw_1", Uo = "_icon_1ohmw_7", Qo = "_dots_1ohmw_14", Jo = "_dot_1ohmw_14", Yo = "_sm_1ohmw_27", Zo = "_md_1ohmw_32", ee = {
  wrapper: Vo,
  icon: Uo,
  dots: Qo,
  dot: Jo,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: Yo,
  md: Zo
};
function qc({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: ee.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: ee.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [ee.dots, ee[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: ee.dot }), /* @__PURE__ */ e.createElement("span", { className: ee.dot }), /* @__PURE__ */ e.createElement("span", { className: ee.dot })));
}
const es = "_container_85404_1", ts = "_table_85404_9", as = "_row_85404_31", ns = "_striped_85404_35", os = "_clickable_85404_43", ss = "_alignLeft_85404_47", rs = "_alignCenter_85404_51", cs = "_alignRight_85404_55", ls = "_emptyCell_85404_59", W = {
  container: es,
  table: ts,
  row: as,
  striped: ns,
  clickable: os,
  alignLeft: ss,
  alignCenter: rs,
  alignRight: cs,
  emptyCell: ls
};
function zc({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? W.alignCenter : l === "right" ? W.alignRight : W.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: W.container }, /* @__PURE__ */ e.createElement("table", { className: W.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: W.emptyCell, colSpan: t.length }, r)) : a.map((l, i) => {
    const c = [
      W.row,
      n && i % 2 === 1 ? W.striped : "",
      o ? W.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: i,
        className: c,
        onClick: o ? () => o(l, i) : void 0
      },
      t.map((d) => /* @__PURE__ */ e.createElement("td", { key: d.key, className: s(d.align) }, l[d.key]))
    );
  }))));
}
const is = "_grid_plbcd_1", ds = "_cell_plbcd_6", _s = "_primaryCell_plbcd_16", ms = "_label_plbcd_21", us = "_value_plbcd_26", ps = "_note_plbcd_32", oe = {
  grid: is,
  cell: ds,
  primaryCell: _s,
  label: ms,
  value: us,
  note: ps
};
function Wc({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: i,
  primaryLabelColor: c,
  primaryValueColor: d,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: oe.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const b = n && u === 0, y = [oe.cell, b ? oe.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), b && i !== void 0 && (E.background = i, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), b && c !== void 0 && (h.color = c);
      const $ = {};
      l !== void 0 && ($.color = l), b && d !== void 0 && ($.color = d);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: oe.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: oe.value, style: $ }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: oe.note, style: X }, _.note));
    })
  );
}
const Es = "_button_16ajt_1", bs = "_disabledSolid_16ajt_19", fs = "_icon_16ajt_26", ys = "_label_16ajt_32", gs = "_fullWidth_16ajt_37", hs = "_sm_16ajt_41", vs = "_md_16ajt_47", ks = "_lg_16ajt_53", Ns = "_primary_16ajt_59", $s = "_secondary_16ajt_70", ws = "_outline_16ajt_81", As = "_ghost_16ajt_93", xs = "_active_16ajt_104", Xs = "_colorOverride_16ajt_116", Ss = "_gradient_16ajt_126", Cs = "_dashed_16ajt_135", Fs = "_pill_16ajt_139", I = {
  button: Es,
  disabledSolid: bs,
  icon: fs,
  label: ys,
  fullWidth: gs,
  sm: hs,
  md: vs,
  lg: ks,
  primary: Ns,
  secondary: $s,
  outline: ws,
  ghost: As,
  active: xs,
  colorOverride: Xs,
  gradient: Ss,
  dashed: Cs,
  pill: Fs
};
function Kc({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: i,
  fullWidth: c = !1,
  type: d = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: $ = "solid",
  shape: X = "rounded"
}) {
  const R = _ !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    I.button,
    I[t],
    I[a],
    c ? I.fullWidth : "",
    r && s === "solid" ? I.disabledSolid : "",
    m ? I.active : "",
    R ? I.colorOverride : "",
    h || u ? I.gradient : "",
    $ === "dashed" ? I.dashed : "",
    X === "pill" ? I.pill : ""
  ].filter(Boolean).join(" "), G = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = n && /* @__PURE__ */ e.createElement("span", { className: I.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: d,
      className: O,
      style: G,
      disabled: r,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: I.label }, i),
    o === "trailing" && V
  );
}
const Bs = "_iconButton_1oiog_1", js = "_sm_1oiog_18", Ls = "_md_1oiog_23", Is = "_lg_1oiog_28", Ds = "_plain_1oiog_33", Ms = "_outline_1oiog_42", Rs = "_circle_1oiog_53", Ts = "_bordered_1oiog_62", Ps = "_tint_1oiog_73", Os = "_active_1oiog_81", Gs = "_hoverBgOverride_1oiog_92", qs = "_gradient_1oiog_96", J = {
  iconButton: Bs,
  sm: js,
  md: Ls,
  lg: Is,
  plain: Ds,
  outline: Ms,
  circle: Rs,
  bordered: Ts,
  tint: Ps,
  active: Os,
  hoverBgOverride: Gs,
  gradient: qs
};
function Hc({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: i = !1,
  color: c,
  hoverColor: d,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: $
}) {
  const X = typeof o == "number", R = [
    J.iconButton,
    X ? "" : J[o],
    J[r],
    n ? J.active : "",
    m ? J.bordered : "",
    b ? J.tint : "",
    h !== void 0 ? J.hoverBgOverride : "",
    $ ? J.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...d !== void 0 ? { "--ax-icon-hover": d } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...$ ? { background: `linear-gradient(135deg, ${$[0]}, ${$[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: R,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: i,
      title: a,
      "aria-label": a
    },
    t
  );
}
const zs = "_control_1kv40_1", Ws = "_option_1kv40_10", Ks = "_active_1kv40_28", Hs = "_sm_1kv40_37", Vs = "_md_1kv40_43", Us = "_dot_1kv40_49", Qs = "_count_1kv40_56", Js = "_outline_1kv40_70", Ys = "_outlineOption_1kv40_75", K = {
  control: zs,
  option: Ws,
  active: Ks,
  sm: Hs,
  md: Vs,
  dot: Us,
  count: Qs,
  outline: Js,
  outlineOption: Ys
};
function Vc({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: i
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const d = c.value === a, m = d ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...i !== void 0 ? { borderColor: i } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": d,
          className: [K.option, d ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const Zs = "_chip_8jgxm_1", er = "_clickable_8jgxm_14", tr = "_suggested_8jgxm_23", ar = "_readonly_8jgxm_33", nr = "_plusIcon_8jgxm_39", or = "_label_8jgxm_45", sr = "_removeButton_8jgxm_50", se = {
  chip: Zs,
  clickable: er,
  default: "_default_8jgxm_18",
  suggested: tr,
  readonly: ar,
  plusIcon: nr,
  label: or,
  removeButton: sr
};
function Uc({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const i = [se.chip, se[a], o ? se.clickable : ""].filter(Boolean).join(" "), d = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: se.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: se.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: se.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: i,
      style: d,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: i, style: d }, _);
}
const rr = "_wrapper_15dm4_1", cr = "_disabled_15dm4_8", lr = "_track_15dm4_13", ir = "_checked_15dm4_30", dr = "_thumb_15dm4_34", _r = "_label_15dm4_50", re = {
  wrapper: rr,
  disabled: cr,
  track: lr,
  checked: ir,
  thumb: dr,
  label: _r
};
function Qc({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const mr = "_card_1uh3t_1", ur = "_active_1uh3t_24", pr = "_iconChip_1uh3t_29", Er = "_body_1uh3t_41", br = "_label_1uh3t_48", fr = "_description_1uh3t_54", ce = {
  card: mr,
  active: ur,
  iconChip: pr,
  body: Er,
  label: br,
  description: fr
};
function Jc(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: ce.description }, o))
  );
}
const yr = "_breadcrumb_zkol9_1", gr = "_list_zkol9_6", hr = "_item_zkol9_16", vr = "_link_zkol9_22", kr = "_plain_zkol9_43", Nr = "_current_zkol9_48", $r = "_separator_zkol9_54", te = {
  breadcrumb: yr,
  list: gr,
  item: hr,
  link: vr,
  plain: kr,
  current: Nr,
  separator: $r
};
function Yc(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: te.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: te.list }, a.map((i, c) => {
    const d = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: te.item }, d ? /* @__PURE__ */ e.createElement("span", { className: te.current, "aria-current": "page" }, i.label) : i.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: te.link,
        onClick: i.onClick
      },
      i.label
    ) : /* @__PURE__ */ e.createElement("span", { className: te.plain }, i.label), !d && /* @__PURE__ */ e.createElement("span", { className: te.separator, "aria-hidden": "true" }, n));
  })));
}
const wr = "_treeItem_1ouqz_1", Ar = "_active_1ouqz_18", xr = "_chevron_1ouqz_28", Xr = "_chevronExpanded_1ouqz_48", Sr = "_chevronSpacer_1ouqz_52", Cr = "_icon_1ouqz_57", Fr = "_label_1ouqz_69", Br = "_count_1ouqz_76", jr = "_dark_1ouqz_86", H = {
  treeItem: wr,
  active: Ar,
  chevron: xr,
  chevronExpanded: Xr,
  chevronSpacer: Sr,
  icon: Cr,
  label: Fr,
  count: Br,
  dark: jr
};
function Zc(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: i = !1,
    theme: c = "light",
    onToggleExpand: d,
    onClick: m
  } = t, _ = (b) => {
    b.stopPropagation(), d == null || d();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? i : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${i ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": i ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const Lr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Pe(t) {
  return Array.from(t.querySelectorAll(Lr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let Oe = 0, Ge = "";
function Qe(t) {
  const a = Y(null), n = Y(t);
  n.current = t;
  const o = Y(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), ae(() => {
    var i;
    const s = a.current, l = (i = o.current) != null ? i : null;
    return s && !s.contains(document.activeElement) && (Pe(s)[0] || s).focus(), Oe++ === 0 && (Ge = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Oe === 0 && (document.body.style.overflow = Ge), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const i = Pe(l);
    if (i.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = i[0], d = i[i.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), d.focus()) : !s.shiftKey && m === d && (s.preventDefault(), c.focus());
  } };
}
const Ir = "_backdrop_gstyy_1", Dr = "_panel_gstyy_9", Mr = "_right_gstyy_21", Rr = "_left_gstyy_27", Tr = "_header_gstyy_51", Pr = "_icon_gstyy_59", Or = "_titleGroup_gstyy_66", Gr = "_kicker_gstyy_71", qr = "_title_gstyy_66", zr = "_subtitle_gstyy_87", Wr = "_closeButton_gstyy_93", Kr = "_body_gstyy_115", Hr = "_footer_gstyy_123", j = {
  backdrop: Ir,
  panel: Dr,
  right: Mr,
  left: Rr,
  header: Tr,
  icon: Pr,
  titleGroup: Or,
  kicker: Gr,
  title: qr,
  subtitle: zr,
  closeButton: Wr,
  body: Kr,
  footer: Hr
};
function el(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Vr, { ...t }) : null;
}
function Vr({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: i,
  children: c,
  side: d = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: b } = Qe(t), y = qe("ax-drawer-t"), E = [j.panel, d === "left" ? j.left : j.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, $ = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: j.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: $,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: j.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: j.icon }, a), /* @__PURE__ */ e.createElement("div", { className: j.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: j.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: j.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: j.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: j.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: j.body }, c),
    i && /* @__PURE__ */ e.createElement("div", { className: j.footer }, i)
  ));
}
const Ur = "_backdrop_6kso7_1", Qr = "_menu_6kso7_8", Jr = "_alignRight_6kso7_24", Yr = "_alignLeft_6kso7_28", Zr = "_item_6kso7_32", ec = "_itemIcon_6kso7_50", tc = "_itemText_6kso7_59", ac = "_itemLabel_6kso7_66", nc = "_itemDescription_6kso7_72", oc = "_danger_6kso7_77", T = {
  backdrop: Ur,
  menu: Qr,
  alignRight: Jr,
  alignLeft: Yr,
  item: Zr,
  itemIcon: ec,
  itemText: tc,
  itemLabel: ac,
  itemDescription: nc,
  danger: oc
};
function tl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(sc, { ...t }) : null;
}
function sc({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = Y(null), r = Y(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), ae(() => {
    var d, m, _;
    const c = (d = r.current) != null ? d : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [T.menu, n === "left" ? T.alignLeft : T.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, i = (c) => {
    var u, b;
    const d = Array.from((b = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? b : []), m = d.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = d[(y + d.length) % d.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? d.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(d.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(Je, null, /* @__PURE__ */ e.createElement("div", { className: T.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: i }, a.map((c, d) => {
    const m = [T.item, c.danger ? T.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: d,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: T.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: T.itemText }, /* @__PURE__ */ e.createElement("span", { className: T.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: T.itemDescription }, c.description))
    );
  })));
}
const rc = "_backdrop_3pc9i_1", cc = "_card_3pc9i_12", lc = "_header_3pc9i_23", ic = "_icon_3pc9i_31", dc = "_titleGroup_3pc9i_38", _c = "_title_3pc9i_38", mc = "_subtitle_3pc9i_50", uc = "_closeButton_3pc9i_56", pc = "_body_3pc9i_78", Ec = "_footer_3pc9i_85", P = {
  backdrop: rc,
  card: cc,
  header: lc,
  icon: ic,
  titleGroup: dc,
  title: _c,
  subtitle: mc,
  closeButton: uc,
  body: pc,
  footer: Ec
};
function al(t) {
  return t.open ? /* @__PURE__ */ e.createElement(bc, { ...t }) : null;
}
function bc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: i, onKeyDown: c } = Qe(t), d = qe("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: i,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": d,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: d }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  Jc as AXActionCard,
  Xc as AXAiIconBadge,
  Rc as AXAiSuggestionBanner,
  Ue as AXAvatar,
  Sc as AXAvatarStack,
  Cc as AXBadge,
  Yc as AXBreadcrumb,
  Kc as AXButton,
  wc as AXCardPanel,
  Fc as AXCommentRow,
  Nc as AXCommentThread,
  zc as AXDataTable,
  Ac as AXDivider,
  el as AXDrawer,
  tl as AXDropdownMenu,
  Tc as AXEmptyState,
  sl as AXErpAccordion,
  rl as AXErpActionMenu,
  cl as AXErpBanner,
  ll as AXErpBarChart,
  il as AXErpButton,
  dl as AXErpCalculatorModal,
  _l as AXErpCalculatorProvider,
  ml as AXErpCalendar,
  ul as AXErpCard,
  pl as AXErpCheckGroup,
  El as AXErpCheckList,
  bl as AXErpCheckbox,
  fl as AXErpCodePicker,
  yl as AXErpContextHelp,
  gl as AXErpCriticalAlert,
  hl as AXErpCsvButton,
  vl as AXErpDatePicker,
  kl as AXErpDateRange,
  Nl as AXErpDonutChart,
  $l as AXErpError,
  wl as AXErpField,
  Al as AXErpFileDrop,
  xl as AXErpFilterBand,
  Xl as AXErpFormRow,
  Sl as AXErpFormSection,
  Cl as AXErpGantt,
  Fl as AXErpGisuField,
  Bl as AXErpGlyph,
  jl as AXErpGrid,
  Ll as AXErpGridStatus,
  Il as AXErpHint,
  Dl as AXErpIcon,
  Ml as AXErpIconButton,
  Rl as AXErpKanban,
  Tl as AXErpKpiTile,
  Pl as AXErpKpiTileGroup,
  Ol as AXErpLinkButton,
  Gl as AXErpLoadMore,
  ql as AXErpMainScreen,
  zl as AXErpMenuAreaHead,
  Wl as AXErpMenuGroup,
  Kl as AXErpMiniCalendar,
  Hl as AXErpModal,
  Vl as AXErpMoneyInput,
  Ul as AXErpMsg,
  Ql as AXErpNote,
  Jl as AXErpOverviewGrid,
  Yl as AXErpPage,
  Zl as AXErpPagination,
  ei as AXErpPill,
  ti as AXErpProgressBar,
  ai as AXErpProposalBanner,
  ni as AXErpProposalCards,
  oi as AXErpProposalList,
  si as AXErpProposalModal,
  ri as AXErpQtyInput,
  ci as AXErpQuickMenu,
  li as AXErpRadioGroup,
  ii as AXErpReadonly,
  di as AXErpReadout,
  _i as AXErpSaveBar,
  mi as AXErpSearchBar,
  ui as AXErpSelect,
  pi as AXErpShortcutHelp,
  Ei as AXErpSideBar,
  bi as AXErpSidePanel,
  fi as AXErpSidePanelGroup,
  yi as AXErpSkipLink,
  gi as AXErpSortAnnounce,
  hi as AXErpSortTh,
  vi as AXErpSpinner,
  ki as AXErpStartGuide,
  Ni as AXErpStatCard,
  $i as AXErpStateBadge,
  wi as AXErpStepIndicator,
  Ai as AXErpSummaryCard,
  xi as AXErpSummaryList,
  Xi as AXErpTabs,
  Si as AXErpTag,
  Ci as AXErpTagList,
  Fi as AXErpTextInput,
  Bi as AXErpTitleBar,
  ji as AXErpToastProvider,
  Li as AXErpToggle,
  Ii as AXErpTooltip,
  Di as AXErpTreeCell,
  Mi as AXErpVerify,
  Ri as AXErpVirtualBody,
  Ti as AXErpVisuallyHidden,
  Pi as AXErpWeekStepper,
  Oi as AXErpWeekStrip,
  Pc as AXExpandableSummary,
  Bc as AXFileChip,
  Va as AXFileTypeIcon,
  Hc as AXIconButton,
  Wc as AXKeyValueGrid,
  jc as AXKeyValueRow,
  Lc as AXListRow,
  al as AXModal,
  xc as AXPanelHeader,
  Ic as AXPersonRow,
  Oc as AXProgressBar,
  Dc as AXRankingRow,
  Gi as AXSearchInput,
  Vc as AXSegmentedControl,
  Mc as AXStatusBadge,
  Gc as AXStepProgress,
  Uc as AXTagChip,
  Qc as AXToggleSwitch,
  Zc as AXTreeItem,
  qc as AXTypingDots,
  qi as AX_ERP_CALENDAR_KO,
  zi as AX_ERP_DIRTY_MESSAGE,
  Wi as AX_ERP_SHORTCUTS,
  ze as GW_ORIGIN,
  Ki as JAPANESE_ERAS,
  Hi as OBTPortal,
  Vi as OBTResizeContainer,
  Ui as OBTResizeSensor,
  ye as REFRESH_KEY,
  Ae as SESSION_EXPIRED_EVENT,
  Se as TOKEN_KEY,
  Qi as amDigits,
  Ji as amNumber,
  ge as authorizedFetch,
  Yi as axErpAddDays,
  Zi as axErpAriaSort,
  ed as axErpCalendarLocale,
  td as axErpChangedKeys,
  ad as axErpCodeDisplay,
  nd as axErpCodeLabel,
  od as axErpCodeNameOf,
  sd as axErpCompareSortValue,
  rd as axErpDownload,
  cd as axErpFileName,
  ld as axErpGisuLabel,
  id as axErpHttpMessage,
  dd as axErpIsHelpKey,
  _d as axErpKeepInPlace,
  md as axErpKpiColumns,
  ud as axErpMenuItem,
  pd as axErpMenuSection,
  Ed as axErpMergeBase,
  bd as axErpNextSort,
  fd as axErpPageCount,
  yd as axErpPageItems,
  gd as axErpParsePage,
  hd as axErpQtyDecimals,
  vd as axErpQtyFormat,
  kd as axErpQtyOutOfRange,
  Nd as axErpQtyParse,
  $d as axErpQtyRound,
  wd as axErpQtyStep,
  Ad as axErpRangeValid,
  xd as axErpRovingMove,
  Xd as axErpRowActivate,
  Sd as axErpSameValues,
  Cd as axErpSaveBlob,
  Fd as axErpSaveCsv,
  Bd as axErpSortForest,
  jd as axErpSortMessage,
  Ld as axErpSortValue,
  Id as axErpSubmitShortcutLabel,
  Dd as axErpTableToCsv,
  Md as axErpTotalLabel,
  Rd as axErpWeekOf,
  tt as clearTokens,
  gc as colors,
  hc as configureAuth,
  kc as configureComments,
  Td as csvFormulaGuard,
  Pd as csvNumber,
  Ce as decodeClaims,
  Od as eraOf,
  Gd as eraShortDate,
  qd as eraYearLabel,
  zd as fmtAm,
  Wd as fmtDt,
  rt as getFreshToken,
  Ze as getStoredToken,
  Ye as isExpired,
  Ke as isRefreshExpired,
  ct as isReply,
  Kd as measureMoneyMetrics,
  Hd as moneyColWidth,
  Vd as moneyColWidthForDigits,
  be as notifySessionExpired,
  vc as onSessionExpired,
  Ve as refreshTokens,
  et as saveTokens,
  nt as startRefreshExpiryWatch,
  He as stopRefreshExpiryWatch,
  Ud as textColWidth,
  Qd as textWidth,
  Jd as toHalfWidth,
  Yd as todayLocal,
  Zd as useAXErpBusy,
  e_ as useAXErpCalculator,
  t_ as useAXErpConfirm,
  a_ as useAXErpDirtyGuard,
  n_ as useAXErpEditor,
  o_ as useAXErpNotice,
  s_ as useAXErpQuickMenu,
  r_ as useAXErpRovingGrid,
  c_ as useAXErpShortcutHelp,
  l_ as useAXErpSubmitShortcut,
  i_ as useAXErpToast,
  d_ as useAXErpTree,
  qe as useAXErpUid,
  $c as useCommentCounts,
  ut as useComments
};
